import { createContext, useContext } from 'react';
import { useExtendSearchParams } from './useExtendSearchParams';

export const LocalSearchParamsContext = createContext<ReturnType<typeof useExtendSearchParams> | null>(null);

/**
 * Параметры выдачи грида: в модалке берём локальное состояние, на странице — URL.
 * Навигация и предпросмотр продолжают использовать useExtendSearchParams.
 * @kind helper
 */
export function useGridSearchParams() {
    const localSearchParams = useContext(LocalSearchParamsContext);
    const urlSearchParams = useExtendSearchParams();

    return localSearchParams ?? urlSearchParams;
}
